module.exports = __webpack_public_path__ + "img/img_realtorCouncil_2019.dac05332.png";